import { z } from 'zod';

import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const ResearchRequestHypothesisSchema = z.object({
  researchRequestHypothesisId: PrimaryKeySchema,
  researchRequestQueryId: PrimaryKeySchema,
  hypothesis: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ResearchRequestHypothesis = z.infer<
  typeof ResearchRequestHypothesisSchema
>;

export const ResearchRequestHypothesesSchema = z.array(
  ResearchRequestHypothesisSchema,
);

export type ResearchRequestHypotheses = z.infer<
  typeof ResearchRequestHypothesesSchema
>;

export const ResearchRequestHypothesesQuerySchema = z.object({
  researchRequestHypothesisIds: commaDelimitedList(
    PrimaryKeySchema.array(),
  ).optional(),
  researchRequestQueryIds: commaDelimitedList(
    PrimaryKeySchema.array(),
  ).optional(),
  researchRequestIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
  hasEvidence: z.boolean().optional(),
});

export type ResearchRequestHypothesesQuery = z.infer<
  typeof ResearchRequestHypothesesQuerySchema
>;

export const CreateResearchRequestHypothesisSchema =
  ResearchRequestHypothesisSchema.pick({
    researchRequestQueryId: true,
    hypothesis: true,
  });

export type CreateResearchRequestHypothesis = z.infer<
  typeof CreateResearchRequestHypothesisSchema
>;
